<template>
    <div class="form-subscription-cancel">
        <p class="text-zinc-700 mb-6">
            Are you sure you want to cancel this subscription? This action cannot be undone.
        </p>
        <div class="flex gap-3">
            <button-regular buttonText="Back" @click="abortCancellation"></button-regular>
            <div class="grow"></div>
            <button-primary
                :buttonDisabled="disabled"
                buttonText="Confirm"
                :buttonClick="confirmCancellation"
            ></button-primary>
        </div>
        <alert-error :alert="error" class="mt-4"></alert-error>
    </div>
</template>

<script>
import {mapState, mapActions} from 'pinia';

export default {
    name: 'FormSubscriptionCancel',
    emits: ['closed'],
    computed: {
        ...mapState(useStoreSubscription, {
            disabled: 'disabled',
            error: 'error',
        }),
    },
    methods: {
        ...mapActions(useStoreSubscription, {
            putSubscriptionCancelled: 'putSubscriptionCancelled',
        }),
        async confirmCancellation() {
            await this.putSubscriptionCancelled();
            this.$emit('closed');
        },
        abortCancellation() {
            this.$emit('closed');
        },
    },
};
</script>
